import { render, staticRenderFns } from "./EHorizontalBarChart.vue?vue&type=template&id=72088013&"
import script from "./EHorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./EHorizontalBarChart.vue?vue&type=script&lang=js&"
import style0 from "./EHorizontalBarChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports